import Token from './token'
import Form from './form'

export default {
  icon: 'play',
  label: 'Play Recording',
  type: 'voice',
  action: 'play',
  form: Form,
  token: Token
}
